// eslint-disable-next-line import/no-cycle
import { DateTimeFormat, toDateTimeOptions } from './core';
/**
 * Number.prototype.toLocaleString ponyfill
 * https://tc39.es/ecma402/#sup-number.prototype.tolocalestring
 */
export function toLocaleString(x, locales, options) {
    var dtf = new DateTimeFormat(locales, options);
    return dtf.format(x);
}
export function toLocaleDateString(x, locales, options) {
    var dtf = new DateTimeFormat(locales, toDateTimeOptions(options, 'date', 'date'));
    return dtf.format(x);
}
export function toLocaleTimeString(x, locales, options) {
    var dtf = new DateTimeFormat(locales, toDateTimeOptions(options, 'time', 'time'));
    return dtf.format(x);
}
//# sourceMappingURL=to_locale_string.js.map